import { PaymentMethodType, PaymentServiceType } from '@dni-types/data-models/ecommerce-payment'
import { CheckoutPayAlipayHkModule } from './checkout-pay/CheckoutPayAlipayHkModule'
import { CheckoutPayApplePayModule } from './checkout-pay/CheckoutPayApplePayModule'
import { CheckoutPayCreditCardModule } from './checkout-pay/CheckoutPayCreditCardModule'
import { CheckoutPayWeChatPayHkModule } from './checkout-pay/CheckoutPayWeChatPayHkModule'
import { ECPayCreditCardModule } from './ECPayCreditCardModule'
import { TappayApplePayModule } from './TappayApplePayModule'
import { TappayCreditCardModule } from './TappayCreditCardModule'
import { TappayJkoPayModule } from './TappayJkoPayModule'
import { TappayLinePayModule } from './TappayLinePayModule'

const paymentModuleMap = {
  [PaymentServiceType.TAPPAY]: {
    [PaymentMethodType.CREDIT_CARD_ONCE]: TappayCreditCardModule.getInstance(),
    [PaymentMethodType.CREDIT_CARD_INSTALLMENT]: TappayCreditCardModule.getInstance(),
    [PaymentMethodType.JKO_PAY]: new TappayJkoPayModule(),
    [PaymentMethodType.APPLE_PAY]: new TappayApplePayModule(),
    [PaymentMethodType.LINE_PAY]: new TappayLinePayModule(),
  },
  [PaymentServiceType.CHECKOUTPAY]: {
    [PaymentMethodType.CREDIT_CARD_ONCE]: new CheckoutPayCreditCardModule(),
    [PaymentMethodType.APPLE_PAY]: new CheckoutPayApplePayModule(),
    [PaymentMethodType.ALIPAY_HK]: new CheckoutPayAlipayHkModule(),
    [PaymentMethodType.WECHAT_PAY]: new CheckoutPayWeChatPayHkModule(),
  },
  [PaymentServiceType.ECPAY]: {
    [PaymentMethodType.CREDIT_CARD_ONCE]: ECPayCreditCardModule.getInstance(),
    [PaymentMethodType.CREDIT_CARD_INSTALLMENT]: ECPayCreditCardModule.getInstance(),
  },
}

export const getPaymentModule = (serviceType: PaymentServiceType, type: PaymentMethodType) => {
  if (serviceType === PaymentServiceType.TAPPAY) {
    const paymentModule = paymentModuleMap[serviceType]
    if (type in paymentModule) {
      return paymentModule[type as keyof typeof paymentModule]
    }
  }
  if (serviceType === PaymentServiceType.CHECKOUTPAY) {
    const paymentModule = paymentModuleMap[serviceType]
    if (type in paymentModule) {
      return paymentModule[type as keyof typeof paymentModule]
    }
  }
  if (serviceType === PaymentServiceType.ECPAY) {
    const paymentModule = paymentModuleMap[serviceType]
    if (type in paymentModule) {
      return paymentModule[type as keyof typeof paymentModule]
    }
  }
  return undefined
}

export type PaymentModuleMap = typeof paymentModuleMap
export type PaymentModuleUnion = ReturnType<typeof getPaymentModule>

const PAYMENT_METHODS_REQUIRING_MODULE = [PaymentMethodType.CREDIT_CARD_ONCE, PaymentMethodType.CREDIT_CARD_INSTALLMENT]

export const requiresPaymentModule = (type: PaymentMethodType) => PAYMENT_METHODS_REQUIRING_MODULE.includes(type)
